import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

const loader = new GLTFLoader();

/** Promise-wrapped GLTFLoader. Rejects with a message naming the file. */
export function loadGLTF(url) {
  return new Promise((resolve, reject) => {
    loader.load(
      url,
      resolve,
      undefined,
      (error) => reject(new Error(`failed to load ${url}: ${error?.message ?? error}`))
    );
  });
}

/** First SkinnedMesh in a loaded scene, or null if the model has no rig. */
export function findSkinnedMesh(object) {
  let found = null;
  object.traverse((child) => {
    if (!found && child.isSkinnedMesh) found = child;
  });
  return found;
}
